import { all, AllEffect, fork, ForkEffect } from 'redux-saga/effects';
import { listDevBoxOperationsListenerSaga } from './list-dev-box-operations';
import { loadDevBoxOperationsForDevBoxesListenerSaga } from './load-dev-box-operations-for-dev-boxes';

export function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
    yield all([fork(listDevBoxOperationsListenerSaga), fork(loadDevBoxOperationsForDevBoxesListenerSaga)]);
}
